export default {
    apiurl: 'https://doesnotexist.execute-api.us-east-2.amazonaws.com/prod',
    remote: 'https://localhost:8765/',
    debug: process.env.NODE_ENV === 'development',
}
